import { Reveal, Eyebrow } from "./Reveal";
import { FAQ_ITEMS, REASSURANCE } from "../../data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { ShieldCheck } from "lucide-react";

export const FAQ = () => {
  return (
    <section id="faq" className="relative bg-sand-light py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16 items-start">
        <div className="lg:sticky lg:top-28">
          <Reveal><Eyebrow>Questions fréquentes</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-serif font-semibold tracking-tight text-ocean text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              Tout ce qu'il faut savoir avant de vous lancer
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 flex gap-3 rounded-3xl bg-palm-light border border-palm/10 p-5" data-testid="reassurance-note">
              <ShieldCheck className="w-6 h-6 text-palm flex-shrink-0" strokeWidth={1.8} />
              <p className="text-sm text-palm leading-relaxed font-medium">{REASSURANCE}</p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible defaultValue="faq-0" className="w-full" data-testid="faq-accordion">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-ocean/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-serif text-lg sm:text-xl text-ocean hover:no-underline py-5 [&>svg]:text-gold [&>svg]:h-5 [&>svg]:w-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted2 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
